<div class="word-break">
    <span>{{i18n.newVersion}}</span>
    <a (click)="jump()">{{' ' + i18n.check}}</a>
</div>

